import { Controller } from 'stimulus';
import Alert from '../error/notice'

export default class extends Controller {
  static targets = ["industrySelect", "categorySelect", "newCategoryField"]

  connect() {
    if (this.hasCategorySelectTarget && this.hasIndustrySelectTarget) {
      this.updateCategories()
      this.categorySelectTarget.addEventListener("change", () => this.toggleNewCategory())

      this.ensureAddNewOption()
    }
  }

  async updateCategories() {
    this.industrySelectTarget.addEventListener("change", () => {
      const industryId = this.industrySelectTarget.value
      if (!industryId) {
        this.populateDefaultOptions()
        return
      }

      fetch(`/industries/${industryId}/role_categories.json`)
        .then(res => res.json())
        .then(data => {
          this.categorySelectTarget.innerHTML = ""

          let noCategoryOpt = new Option("No Category", "")
          this.categorySelectTarget.appendChild(noCategoryOpt)

          data.forEach(cat => {
            let opt = new Option(cat.name, cat.id)
            this.categorySelectTarget.appendChild(opt)
          })

          let newOpt = new Option("Add New", "new")
          this.categorySelectTarget.appendChild(newOpt)
        })
    })
  }

  ensureAddNewOption() {
    const industryId = this.industrySelectTarget.value
    if (!industryId) return; 

    if (![...this.categorySelectTarget.options].some(o => o.value === "new")) {
      let newOpt = new Option("Add New", "new")
      this.categorySelectTarget.appendChild(newOpt)
    }
  }

  toggleNewCategory() {
    this.newCategoryFieldTarget.style.display =
      this.categorySelectTarget.value === "new" ? "block" : "none"
  }

  populateDefaultOptions() {
    this.categorySelectTarget.innerHTML = ""
    this.categorySelectTarget.appendChild(new Option("No Category", ""))
    this.categorySelectTarget.appendChild(new Option("Add New", "new"))
  }

  saveConfiguration() {
    $('#text' + this.data.get('field')).keyup(function() {
      let nameField = $(this).closest('form').find('input#submitButton');
      if(($(this).val().trim().length < 1))
        nameField.attr('disabled', true);
      else
        nameField.attr('disabled', false);
    });
  }

  hideAlert(event) {
    event.preventDefault();
    $('#alert').hide();
  }

  async editForm() {
    const url = this.data.get("url");

    fetch(url, { headers: { "Accept": "text/vnd.turbo-stream.html" } })
      .then(res => res.text())
      .then(html => {
        document.getElementById("edit-form-container").innerHTML = html;
        $("#edit-configuration-modal").foundation("open");
      });
  }

  toggle(event) {
    event.preventDefault();
    $('#' + this.data.get('field')).hide();
    $('#' + this.data.get('id')).show();
  }

  deleteConfiguration(event) {
    event.preventDefault();
    const systemConfigurationsId = this.element.dataset.systemConfigurationsId;
    const deleteConfigurationId = document.querySelector("#delete-configuration-modal");
    deleteConfigurationId.setAttribute("data-system-configurations-id", systemConfigurationsId);
    openModal(deleteConfigurationId);
  }

  async saveDeleteConfiguration(event) {
    event.preventDefault();
    const deleteConfigurationId = document.querySelector("#delete-configuration-modal");
    const systemConfigurationsId = deleteConfigurationId.getAttribute("data-system-configurations-id");

    try {
      if (systemConfigurationsId.startsWith('industry')) {
        const response = await fetch(`/supers/industries/${systemConfigurationsId.split('_')[1]}`, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
          },
        });
      }
      else if (systemConfigurationsId.startsWith('role_category')) {
        const response = await fetch(`/supers/role_categories/${systemConfigurationsId.split('_')[2]}`, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
          },
        });
      }
      else if (systemConfigurationsId.startsWith('role') || systemConfigurationsId.startsWith('placement')) {
        const response = await fetch(`/supers/${systemConfigurationsId.split('_')[0] + 's'}/${systemConfigurationsId.split('_')[1]}`, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
          },
        });
      }
      else {
        const response = await fetch(`/supers/configuration_mappings/${systemConfigurationsId.split('_')[2]}`, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
          },
        });
      }
      location.reload();
    } catch (error) {
      let alert = new Alert
      alert.flashMessage(error)
    }
  }
}
